import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import Spinner from '../CommonComponents/Spinner';
import getImagePath from '../CommonUtils/getImagePath';
import { toggleNotifications, toggleSettings } from '../TopNav/Adviser/TopNavActions';
import { SubscriptionTypeDTO } from './api/useSubscriptionQuery';
import { Payment } from './components/Payment/Payment';
import { Terms } from './components/Terms';
import { useCheckout } from './useCheckout';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

export const Checkout: React.FC = () => {
  const [showTerms, setShowTerms] = useState(true);
  const { data, refetch, isLoading, isError } = useCheckout();
  const dispatch = useDispatch();

  const showTopNavButtons = show => {
    dispatch(toggleNotifications(show));
    dispatch(toggleSettings(show));
  };

  useEffectOnce(() => {
    showTopNavButtons(false);
    setTimeout(() => ADV.util.showAdviserAreaEmptyState(true), 0);

    return () => showTopNavButtons(true);
  });

  useDocumentTitle('Checkout');

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const title =
    data.subscriptionType === SubscriptionTypeDTO.Expired
      ? 'Your subscription has expired'
      : 'Start your Orion Planning subscription';

  return (
    <Box height="100%" display="flex" flexDirection="column" alignItems="center" bg="#fff">
      <Box
        height="170px"
        width="100%"
        background={`#0078D4 url(${getImagePath('intro-bg.png')}) no-repeat 0 60px`}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Text as="h1" mt="32" fontSize="h1" color="#fff" textAlign="center">
          {title}
        </Text>
      </Box>
      <Box flex="1" width="950px" p="48">
        {showTerms ? <Terms onSave={() => setShowTerms(false)} /> : <Payment />}
      </Box>
    </Box>
  );
};
